import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import BaseModal from 'components/Modals/BaseModal'
import { closeModal } from 'store/actions/modals'
import { createEvents, setCopiedEvents } from 'store/actions/events'
import { Button } from 'components/Forms'
import { Loading } from 'components/UI'
import { createErrorNotification, createNotification } from 'store/actions/notifications'
import { TrackAction } from 'services/TrackAction'
import { EventSummaryList } from 'components/Schedule'
import { Format } from 'services/Dates'
import useApi from 'components/Hooks/useApi'
import { Alert } from 'ui'

import { t } from 'translations'

const ScheduleConfirmPasteModal = ({ shiftIds, referenceDate, date, specificDay }) => {
  const dispatch = useDispatch()
  const isRightClickPaste = !referenceDate

  // Queries definition
  const { isLoading, response: events, handleApi: handleShiftsQuery } = useApi({ method: 'POST', url: 'schedule/schedule/query' })
  const { isLoading: pasteQueryLoading, handleApi: handlePasteQuery } = useApi({ method: 'POST', url: 'schedule/paste', initialLoad: false })

  useEffect(() => {
    ;(async () => {
      await handleShiftsQuery({ shiftIds, showCancelledShift: true })
    })()
  }, [handleShiftsQuery, shiftIds])

  const confirm = async () => {
    const { response, isError } = await handlePasteQuery({ shiftIds, referenceDate, date, specificDay })

    if (isError) {
      return dispatch(createErrorNotification())
    }
    dispatch(createNotification({ title: t('manager.schedule.SELECTION_OPTIONS.EVENTS_PASTED_SUCCESSFULLY'), description: '', type: 'success' }))

    // Save the pasted events in redux
    dispatch(createEvents(response))

    // Track that user has pasted shifts (and copied obviously before)
    TrackAction('COPY_PASTE_SHIFTS')
    dispatch(closeModal())
  }

  const clearCopied = () => {
    dispatch(setCopiedEvents([]))
    dispatch(closeModal())
  }

  if (isLoading) return <Loading />

  return (
    <BaseModal hideButtons title={`manager.schedule.CONFIRM_PASTE_MODAL`}>
      <Alert variant="warning" className="mt-2">
        {t(`manager.schedule.CONFIRM_PASTE_MODAL.DESCRIPTION${isRightClickPaste ? '_WITH_DATE' : ''}`, {
          count: shiftIds.length,
          pasteDate: Format(date, { outFormat: 'humanDate' })
        })}
      </Alert>
      <EventSummaryList events={events} outFormat="time" />
      <div className="mt-2">
        <Button text="actions.CONFIRM" isSubmitting={pasteQueryLoading} className="btn btn-primary mr-1" onClick={confirm} />
        <Button text="manager.schedule.CONFIRM_PASTE_MODAL.CLEAR_COPIED_EVENTS" className="btn btn-outline-secondary mr-1" onClick={() => clearCopied()} />
        <Button text="actions.CLOSE" className="btn btn-outline-secondary" onClick={() => dispatch(closeModal())} />
      </div>
    </BaseModal>
  )
}

export default ScheduleConfirmPasteModal
